/** @jsx jsx */

import { Fragment as _, useContext, useState, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';

const MatchingLayout = ({ children }) => {
  const context: any = useContext(interactionContext);
  const isOneColumn = context?.meta?.layout.match('One');

  const [layout, setLayout] = useState(1);

  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!container.current || isOneColumn) {
      return;
    }

    const updateLayout = () => {
      const c = container.current as HTMLDivElement;
      const droppableContainer = c.querySelector(
        '.droppable-container'
      ) as HTMLDivElement;

      const dCWidth = droppableContainer.getBoundingClientRect().width;

      const cWidth = c.getBoundingClientRect().width;
      if (cWidth >= dCWidth * 2 + dCWidth / 2) {
        setLayout(1);
        return;
      }

      if (cWidth < dCWidth * 2 + 20) {
        setLayout(0);
        return;
      }

      setLayout(1);
    };

    updateLayout();

    const tick = setInterval(updateLayout, 1000 / 12);
    //
    return () => {
      clearInterval(tick);
    };
  }, []);

  //
  // console.log({ isOneColumn });
  if (isOneColumn) {
    return children;
  }

  return (
    <div
      ref={container}
      css={css`
        position: relative;
        ${layout === 1 && 'display: flex;'}
        width: 100%;
      `}
    >
      {children}
    </div>
  );
};

export default MatchingLayout;
